import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);



function textCircles(){

    const collidingCircles = $qsa('[data-animation="colliding-circles"]');

    if (!collidingCircles) return;

    [...collidingCircles].forEach(collidingCircle => {


    const timeline = gsap.timeline({
        ease: 'none',
        scrollTrigger: {
            trigger: collidingCircles,
            start: 'top bottom',
            end: '100%',
            scrub: true
        },
        // onComplete: () => {
        //     childSplitTitle.revert();
        //     splitTitle.revert();
        // }
    });
    
    timeline
    .to($qs('[data-name="left-circle"]',collidingCircle),{x: '30%'}, "start")
    .to($qs('[data-name="right-circle"]',collidingCircle),{x: '-30%'}, "start")

})

}


export default textCircles;